// extracted by mini-css-extract-plugin
export var quillEditor = "_mh-1";
export var variable = "_mh-0";